import { MainLayout } from "components/layouts";
import EmployeeForm from "./EmployeeForm";
import { useTranslation } from "react-i18next";

import styles from "../styles/EmployeeCreate.module.css";
import { Breadcrumb, Button, Flex, Space } from "antd";
import { ReactComponent as ImportIcon } from "../../../assets/icon/importIcon.svg";

const EmployeeCreate = (props = {}) => {
  const { t } = useTranslation();

  return (
    <MainLayout>
      <Space direction="vertical" className={styles.container} size={24}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("employee.header"), href: "/employee" },
            { title: t("employee.all"), href: "/employee" },
            { title: t("holiday.label.add_employee") },
          ]}
          />
          <h2>{t("holiday.label.add_employee")}</h2>
        </Flex>

        <div className={styles.cardContainer}>
          <EmployeeForm {...props} />
        </div>
      </Space>
    </MainLayout>
  );
};

export default EmployeeCreate;
